/**
 * Map a NextAuth/back-end sign-in error code to a human message. `authorize()`
 * throws the backend account `status` (e.g. "pending", "banned") as the error,
 * and NextAuth uses "CredentialsSignin" for a rejected credential check.
 */
const MESSAGES: Record<string, string> = {
  CredentialsSignin: "Incorrect username or password.",
  pending:
    "Your account isn't activated yet. Check your email for the activation link.",
  banned:
    "This account has been suspended. Contact support if you think this is a mistake.",
  blocked: "This account has been blocked. Contact support for help.",
};

export function authErrorMessage(
  code: string | null | undefined,
): string | null {
  if (!code) return null;
  return MESSAGES[code] ?? "Something went wrong signing in. Please try again.";
}
